"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuItems = void 0;
exports.menuItems = [
    {
        id: 'machines',
        label: 'machines',
        icon: 'pi-home',
        path: '/machines/list',
    },
    {
        id: 'products',
        label: 'products',
        icon: 'pi-box',
        path: '/products/list',
    },
    {
        id: 'reFills',
        label: 'reFills',
        icon: 'pi-tag',
        path: '/refills/list',
    },
    {
        id: 'orders',
        label: 'orders',
        icon: 'pi-box',
        path: '/orders/list',
    },
    {
        id: 'billing',
        label: 'billing',
        icon: 'pi-box',
        path: '/billing/list',
    },
    {
        id: 'settlement',
        label: 'settlement',
        icon: 'pi-box',
        path: '/settlement/list',
    },
    {
        id: 'advertising',
        label: 'advertising.title',
        icon: 'pi-megaphone',
        path: '/advertising/list',
    },
];
